// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.AuthorizeNetPaymentProfileDto
export class AuthorizeNetPaymentProfileDto extends EntityBaseDto {
    public paymentProfileId: string = null;
    public cardNumber: string = null;
    public cardType: string = null;
    public cardExpiration: string = null;
    public issuerNumber: string = null;
    public firstSeen: Date = null;
    public lastValidated: Date = null;
    public ignoreAvs: boolean = false;
    public ignoreCvc: boolean = false;
    public expMonth: number = null;
    public expYear: number = null;
    public lastAvsResult: string = null;
    public displayName: string = null;
}


    



